import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  useMediaQuery,
  Tabs,
  Paper,
  Tab,
  Box,
  Chip,
  Avatar,
} from "@mui/material";
import BasicInfo from "./BasicInfo";
import ExperienceInfo from "./ExperienceInfo";
import EducationInfo from "./EducationInfo";
import Certifications from "./CertificationInfo";
import DocumentList from "./DocList";
import CandidateInterviewStatus from "./InterviewStatus";
import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

const CandidateProfilePage = ({ isDash }) => {
  const { candidateData, candidateJobData } = useCandidateLayout();

  const [selectedTab, setSelectedTab] = useState(0);
  const [documents, setDocuments] = useState([]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };


  const fetchDocuments = async () => {
    if (!candidateData?.CI_Id) return;

    try {
      const res = await axiosAPI.get(
        `Candidate/getCandidateDocumentsPortal/${candidateData?.CI_Id}`
      );

      if (res?.data?.success) {
        setDocuments(res?.data?.data);
      }
    } catch (err) {
      console.error("Error fetching process flow data:", err);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [candidateData]);

  const [tabs, setTabs] = useState(["Basic Information"]);

  useEffect(() => {
    if (documents?.length > 0) {
      setTabs(["Basic Information", "Documents"]);
    }
  }, [documents]);

  const isMobile = useMediaQuery("(max-width: 1220px)");

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        px: isDash ? 0 : 2,
        py: isDash ? 3 : 0,
        pt: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {!isDash && (
        <>
          <Grid container>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  letterSpacing: `0.5px`,
                  fontSize: "26px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                Profile
              </Typography>
            </Grid>
          </Grid>
          <Grid container alignContent="flex-start" justifyContent="center" sx={{ minHeight: "240px" }}>
            <Grid item xs={12}>

              <Avatar
                src={
                  candidateData?.CI_Photo
                    ? `${process.env.REACT_APP_BASE_URL}/${candidateData.CI_Photo}`
                    : undefined
                }
                sx={{
                  width: 140,
                  height: 140,
                  borderRadius: "50%",
                  border: "3px solid #ccc",
                  boxShadow: 2,
                  mx: "auto",
                }}
              >
                {candidateData?.CI_Name?.[0] || ""}
              </Avatar>

            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontFamily: "Geist, sans-serif",
                  textAlign: "center",
                }}
              >
                {candidateData?.CI_Name || "-"}
              </Typography>
              <Typography
                sx={{ fontFamily: "Geist, sans-serif", textAlign: "center" }}
                variant="body1"
              >
                {candidateData?.CI_Profession || "-"}
              </Typography>
              <Typography
                sx={{ fontFamily: "Geist, sans-serif", textAlign: "center" }}
                variant="body2"
                color="text.secondary"
              >
                Passport No: {candidateData?.CI_PassportNo || "-"}
              </Typography>
            </Grid>
          </Grid>
        </>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ boxShadow: "none" }}>
            {selectedTab === 0 && <BasicInfo candidateData={candidateData} />}
            {selectedTab === 1 && <DocumentList documents={documents} />}
            {/* {selectedTab === 2 && <CandidateInterviewStatus candidateData={candidateData} />} */}
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CandidateProfilePage;
